import React from 'react';
import PropTypes from 'prop-types';

export const ActivityContentWrap = ({ onClick, text }) => (
  <span onClick={onClick} className="g-color--info fw6 pointer">
    {text}
  </span>
);

ActivityContentWrap.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};
ActivityContentWrap.defaultProps = {
  onClick: () => {},
  text: '',
};



// WEBPACK FOOTER //
// ./src/components/Communities/Components/ActivitiesList/ActivityContentWrap.jsx